const REDIRECT_PARAM = 'redirect';
const DEFAULT_AFTER_LOGIN = '/dashboard';

// The auth pages themselves, mirroring publicRoutes in routes/index.js.
// Storing one of these as the target would bounce the user back to login
// right after a successful sign-in.
const AUTH_PATH_PREFIXES = [
  '/login',
  '/forgot-password',
  '/resend-email',
  '/verification-email',
  '/auth/reset-password',
];

// Valid targets that are pointless to store: the outcome is the same as the default.
const IGNORED_PATHS = ['/', DEFAULT_AFTER_LOGIN];

const isSafeRedirect = (target) => {
  if (!target || typeof target !== 'string') return false;

  // Internal paths only: must start with exactly one '/', and must not be an absolute
  // or protocol-relative URL ('//evil.com', '/\evil.com') that would take the user off-domain.
  if (!target.startsWith('/')) return false;
  if (target.startsWith('//') || target.startsWith('/\\')) return false;

  const path = target.split('?')[0];

  // '://' is only dangerous in the path; inside the query (e.g. '/doc?src=https://x')
  // it navigates nowhere, so the query is deliberately left unchecked.
  if (path.includes('://')) return false;
  if (IGNORED_PATHS.includes(path)) return false;
  if (AUTH_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return false;
  }

  return true;
};

export function getCurrentLocationForRedirect() {
  return `${window.location.pathname}${window.location.search}`;
}

export function buildLoginUrl(target, extraParams = {}) {
  const params = new URLSearchParams(extraParams);

  if (isSafeRedirect(target)) {
    params.set(REDIRECT_PARAM, target);
  }

  const query = params.toString();
  return query ? `/login?${query}` : '/login';
}

export function getRedirectTarget(search) {
  const target = new URLSearchParams(search).get(REDIRECT_PARAM);
  return isSafeRedirect(target) ? target : null;
}

export { DEFAULT_AFTER_LOGIN };
